<template>
    <div>
        <div class>
            <Steps :active="1" :stepsShow=true align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
                <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" @click.native="on_click('offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')"  @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card style="min-width:900px;" class="aui-card--fill" shadow="never">
            <el-form label-position="left" class="demo-dynamic">
                <el-row>
                    <el-col :span="9">
                            <span style="color:#f56c6c;">*</span>
                            {{ $t('offering.resource.selectSite') }}
                            <br/>
                            <el-input style="width: 320px; margin-top: 8px;"
                                placeholder=" "
                                v-model="dataForm.siteNameAndClassnameAndType"
                                disabled>
                            </el-input>
                    </el-col>
                </el-row>
            </el-form>
            <br/>
            <div id="divTrainer" class="ax_default">
                <div class="ax_default">
                    <div class="ax_default _btn-default"
                        id="btnDiv"
                        data-label=".btn-default"
                        @click="openSchedulingDialog ('trainer')">
                        <div tabindex="0" id="btnDiv_div">
                        </div>
                        <div class="text " id="btnDiv_text">
                            <p>
                              <span style="text-decoration: none;">{{ $t('offering.resource.trainer') }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="ax_default _图片_" id="picDiv">
                        <img alt="" class="img " id="picDiv_img" src="../../../../../assets/img/learning/trainer.png">
                        <div class="text " id="picDiv_text" style="display: none; visibility: hidden;">
                            <p></p>
                        </div>
                    </div>
                    <el-tooltip placement="bottom-start" effect="light" class="tisp" v-if="tips">
                                <div slot="content">
                                对于教室为腾讯会议的排期，当选择多个培训师时，第一个入会的培训师即为主持人，后进入的培训师为联席主持人。每个会议最多可设置10名联席主持人。<br />培训师腾讯会议企业账号仅能参加会议，无法发起会议。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                              </el-tooltip>
                    <div style="float:right;margin-right:30px;cursor: pointer;">
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <div style="width: 100%;">
                <!-- 表头动态展示 -->
                    <el-table
                        ref="trainerTable"
                        :data="dataForm.trainerList"
                        border
                        style="width: 100%;">
                        <el-table-column :label="$t('offering.resource.trainerno')"
                                    type="index"
                                    width="50"
                                    align="center"
                                    fixed>
                            <template slot-scope="scope">
                                <span>{{scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <!-- 培训师编号 -->
                        <el-table-column prop="trainerCode"
                                    :label="$t('offering.resource.trainerId')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 培训师名称 -->
                        <el-table-column prop="trainerName"
                                    :label="$t('offering.resource.trainerName')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 培训师类型 -->
                        <el-table-column prop="trainerTypeName"
                                    :label="$t('offering.resource.trainerType')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 排期时间（开始） -->
                        <el-table-column prop="starttime"
                                    :label="$t('offering.resource.trainerstarttime')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    :formatter="dateFormat"
                                    fixed>
                        </el-table-column>
                        <!-- 排期时间（结束） -->
                        <el-table-column prop="endtime"
                                    :label="$t('offering.resource.trainerendtime')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    :formatter="dateFormat"
                                    fixed>
                        </el-table-column>
                        <!-- 实际培训时间（天） -->
                        <el-table-column prop="actualdays"
                                    :label="$t('offering.resource.traineractualdays')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    fixed>
                          <template slot="header">
                            <el-tooltip placement="bottom-start" effect="light" >
                              <div slot="content">
                                需要与培训师的排期时间（开始）、排期时间（结束）所选择的时长一致
                              </div>
                              <span>{{$t('offering.resource.traineractualdays')}}
                              <em class="el-icon-question" style="color: #1C69D3"></em></span>
                            </el-tooltip>
                          </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <br/>
            <br/>
            <br/>
            <div id="divRoom" class="ax_default">
                <div class="ax_default">
                    <div class="ax_default _btn-default" id="btnDiv" data-label=".btn-default" @click="openSchedulingDialog ('classroom')">
                        <div tabindex="1" id="btnDiv_div">
                        </div>
                        <div class="text " id="btnDiv_text">
                            <p>
                                <span style="text-decoration: none;">{{ $t('offering.resource.room') }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="ax_default _图片_" id="picDiv">
                        <img alt="" class="img " id="picDiv_img" src="../../../../../assets/img/learning/room.png">
                        <div class="text " id="picDiv_text" style="display: none; visibility: hidden;">
                            <p></p>
                        </div>
                    </div>
                    <el-tooltip placement="bottom-start" effect="light" class="tisp" v-if="tips" >
                                <div slot="content">
                                  当选择腾讯会议教室时，请根据上课人数，选择使用对应大小的会议室。若上课人数与教室方数接近，为保证所有学员均可顺利进入教室，建议适当选择方数更大的教室。<br />例如：上课人数为48人，则选择100方的教室。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                              </el-tooltip>
                    <div style="float:right;margin-right:30px;cursor: pointer;">
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <div style="width: 100%;">
                    <!-- 表头动态展示 -->
                    <el-table
                        ref="roomTable"
                        :data="dataForm.roomList"
                        border
                        style="width: 100%;">
                        <el-table-column :label="$t('offering.resource.roomno')"
                                type="index"
                                width="50"
                                align="center"
                                fixed>
                            <template slot-scope="scope">
                                <span>{{scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <!-- 教室ID -->
                        <el-table-column prop="classroomNo"
                                    :label="$t('offering.resource.roomId')"
                                    hidden
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 教室名称 -->
                        <el-table-column prop="roomName"
                                    :label="$t('offering.resource.roomName')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 教室简称 -->
                        <el-table-column prop="roomCnAbbr"
                                    :label="$t('offering.resource.roomCnAbbr')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 所属场地 -->
                        <el-table-column prop="siteCnName"
                                         :label="$t('offering.resource.roomCnSite')"
                                         header-align="center"
                                         align="center"
                                         min-width="110"
                                         :show-overflow-tooltip=true
                                         fixed>
                        </el-table-column>
                        <!-- 排期时间（开始） -->
                        <el-table-column prop="starttime"
                                    :label="$t('offering.resource.roomstarttime')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    :formatter="dateFormat"
                                    fixed>
                        </el-table-column>
                        <!-- 排期时间（结束） -->
                        <el-table-column prop="endtime"
                                    :label="$t('offering.resource.roomendtime')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    :formatter="dateFormat"
                                    fixed>
                        </el-table-column>
                        <!-- 实际培训时间（天） -->
                        <el-table-column prop="actualdays"
                                    :label="$t('offering.resource.roomactualdays')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                          <template slot="header">
                            <el-tooltip placement="bottom-start" effect="light" >
                              <div slot="content">
                                需要与教室的使用时间（开始）、使用时间（结束）所选择的时长一致
                              </div>
                              <span>{{$t('offering.resource.roomactualdays')}}
                              <em class="el-icon-question" style="color: #1C69D3"></em></span>
                            </el-tooltip>
                          </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <br/>
            <br/>
            <br/>
            <div id="divTencentConference" class="ax_default" v-if="tencentConference">
                <div class="ax_default">
                    <div style="cursor: default;" class="ax_default _btn-default" id="btnDiv" data-label=".btn-default" @click="conferenceRoomClick()">
                        <div tabindex="1" id="btnDiv_div">
                        </div>
                        <div class="text " id="btnDiv_text">
                            <p>
                                <span style="text-decoration: none;">{{ $t('offering.resource.tencentConferenceRoom') }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="ax_default _图片_" id="picDiv">
                        <img class="img " alt="" id="picDiv_img" src="../../../../../assets/img/learning/room.png">
                        <div class="text " id="picDiv_text" style="display: none; visibility: hidden;">
                            <p></p>
                        </div>
                        <el-tooltip placement="bottom-start" effect="light" class="tisp" v-if="tips">
                                <div slot="content">
                                  排期发布时才会创建腾讯会议，已发布排期可查看会议链接。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                        </el-tooltip>
                    </div>
                    <div style="float:right;margin-right:30px;" v-show="linkShow">
                        <a @click="checkClick()" style="cursor:pointer;">
                            <span style="text-decoration: none;">查看会议链接</span>
                        </a>
                    </div>
                     <div style="float:right;margin-right:30px;" v-show="linkShowEnd">
                        <a style="cursor:default; text-decoration:none; color:#C0C4CC">
                            <span style="text-decoration: none;">查看会议链接</span>
                        </a>
                    </div>
                    <div style="float:right;margin-right:30px;cursor: default;" v-show="errorShow">
                        <span style="color:red;text-decoration: none;">腾讯会议正在创建中，请稍后查看</span>
                    </div>
                </div>
            </div>
            <!-- <br v-if="tencentConference"/> -->
            <br v-if="tencentConference"/>
            <br v-if="tencentConference"/>
            <div class="viewConferenceContentClass" v-if="tencentConference">
              <el-form :model="conferenceRoomForm" ref="ruleForm" class="demo-ruleForm" label-width="130px">
                <el-row :gutter="10" class="row_jj">
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span style="color:red;font-size:9px;">*&nbsp;</span>{{$t('offering.resource.conferenceTheme')}}</span>
                      <el-input v-model="conferenceRoomForm.subject"
                                :disabled="true"
                                :placeholder="$t('offering.resource.conferenceTheme')"
                                maxlength="5">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span style="color:red;font-size:9px;">*&nbsp;</span>{{$t('offering.startdate')}}
                      <el-tooltip placement="bottom-start" effect="light" style="margin-left:0">
                                <div slot="content">
                                  腾讯会议开始结束时间可更改，但不可超过排期开始结束时间。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                      </el-tooltip>
                    </span>
                      
                      <div>
                        <el-date-picker type="datetime"
                                        :clearable="false"
                                        :disabled="true"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        default-time="09:00:00"
                                        v-model="conferenceRoomForm.start"
                                        :placeholder="$t('offering.startdate')"
                                        style="width: 100%;">
                        </el-date-picker>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span style="color:red;font-size:9px;">*&nbsp;</span>{{$t('offering.enddate')}}</span>
                      
                      <div>
                        <el-date-picker type="datetime"
                                        :clearable="false"
                                        :disabled="true"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        default-time="17:00:00"
                                        v-model="conferenceRoomForm.end"
                                        :placeholder="$t('offering.enddate')"
                                        style="width: 100%;">
                        </el-date-picker>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10" class="row_jj">
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span style="color:red;font-size:9px;">&nbsp;</span>{{$t('offering.recurringMeeting')}}
                      <el-tooltip placement="bottom-start" effect="light" style="margin-left:0">
                                <div slot="content">
                                  培训时长大于1天时，默认为周期性会议。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                      </el-tooltip>
                    </span>
                      <el-select v-model="conferenceRoomForm.isRecurring" :disabled="true" placeholder="请选择">
                        <el-option
                          v-for="item in isRecurringOptions"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span style="color:red;font-size:9px;">&nbsp;</span>{{$t('offering.repeatFrequency')}}
                      <el-tooltip placement="bottom-start" effect="light" style="margin-left:0">
                                <div slot="content">
                                  重复频率默认为“每天”，若排期时间跨周末但不在周末上课，则可选择“每周一至周五”。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                      </el-tooltip></span>
                      <el-select v-model="conferenceRoomForm.recurrentType" :disabled="true" placeholder="">
                        <el-option
                          v-for="item in recurrentTypeOptions"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span style="color:red;font-size:9px;">&nbsp;</span>{{$t('offering.endRepetition')}}
                      <el-tooltip placement="bottom-start" effect="light" style="margin-left:0">
                                <div slot="content">
                                  结束重复时间为实际排期结束时间。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                      </el-tooltip></span>
                      <!-- <el-date-picker type="datetime"
                                      :clearable="false"
                                      :disabled="true"
                                      value-format="yyyy-MM-dd HH:mm:ss"
                                      format="yyyy-MM-dd HH:mm:ss"
                                      default-time="17:00:00"
                                      v-model="conferenceRoomForm.until"
                                      style="width: 100%;">
                      </el-date-picker> -->
                      <el-date-picker type="date"
                                      :clearable="false"
                                      value-format="yyyy-MM-dd"
                                      format="yyyy-MM-dd"
                                      v-model="conferenceRoomForm.until"
                                      :disabled="true"
                                      style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10" class="row_jj">
                  <el-col :span="8">
                    <el-form-item prop="theme" style="" class="label_text">
                      <span slot="label"><span></span>允许成员提前入会
                      <el-tooltip placement="bottom-start" effect="light" style="margin-left:0">
                                <div slot="content">
                                  老师进入前学员无法进入会议。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                      </el-tooltip>
                    </span>
                      <el-select v-model="conferenceRoomForm.allowBeforeHost" :disabled="true" placeholder="请选择">
                        <el-option
                          v-for="item in allowBeforeHostOptions"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span>成员入会时静音&nbsp;</span>
                      <el-tooltip placement="bottom-start" effect="light" style="margin-left:0">
                                <div slot="content">
                                  默认学员进入后麦克风为静音状态。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                      </el-tooltip>
                    </span>
                      <el-select v-model="conferenceRoomForm.isMuteEnableJoin" :disabled="true" placeholder="请选择">
                        <el-option
                          v-for="item in isMuteEnableJoinOptions"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span style="color:red;font-size:9px;">&nbsp;</span>开启自动录屏
                      <el-tooltip placement="bottom-start" effect="light" style="margin-left:0">
                                <div slot="content">
                                  开启后，培训师进入会议后将自动开启云录制，并上传至腾讯云端。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                      </el-tooltip>
                      </el-tooltip>
                    </span>
                      <el-select v-model="conferenceRoomForm.isAutoRecord" :disabled="true" placeholder="请选择">
                        <el-option
                          v-for="item in isAutoRecordOptions"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10" class="row_jj">
                  <el-col :span="8">
                    <el-form-item prop="theme">
                      <span slot="label"><span style="color:red;font-size:9px;">&nbsp;</span>开启等候室
                      <el-tooltip placement="bottom-start" effect="light" style="margin-left:0">
                                <div slot="content">
                                  开启后，学员进入会议时先进入等候室，老师同意后方可进入会议。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                      </el-tooltip></span>
                      <el-select v-model="conferenceRoomForm.isWaitingRoom" :disabled="true" placeholder="">
                        <el-option
                          v-for="item in isWaitingRoomOptions"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <br v-if="tencentConference"/>
            <br v-if="tencentConference"/>
            <br v-if="tencentConference"/>
            <div id="divVehcle" class="ax_default">
                <div class="ax_default">
                    <div class="ax_default _btn-default" id="btnDiv" data-label=".btn-default" @click="openSchedulingDialog ('vehicle')">
                        <div tabindex="1" id="btnDiv_div">
                        </div>
                        <div class="text " id="btnDiv_text">
                            <p>
                                <span style="text-decoration: none;">{{ $t('offering.resource.vehicle') }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="ax_default _图片_" id="picDiv">
                        <img alt="" class="img " id="picDiv_img" src="../../../../../assets/img/learning/vehicle.png">
                        <div class="text " id="picDiv_text" style="display: none; visibility: hidden;">
                            <p></p>
                        </div>
                    </div>
                    <div style="float:right;margin-right:30px;cursor: pointer;">
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <div style="width: 100%;">
                    <!-- 表头动态展示 -->
                    <el-table
                        ref="vehicleTable"
                        :data="dataForm.vehicleList"
                        borde
                        style="width: 100%;">
                        <el-table-column prop="vehicleId"
                                    :label="$t('offering.resource.vehicleid')"
                                    type="index"
                                    width="50"
                                    align="center"
                                    fixed>
                            <template slot-scope="scope">
                                <span>{{scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <!-- 车架号 -->
                        <el-table-column prop="vehicleNo"
                                    :label="$t('offering.resource.vehicleNo')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 车辆名称 -->
                        <el-table-column prop="vehicleBrand"
                                    :label="$t('offering.resource.vehicleBrand')"
                                    header-align="center"
                                    align="center"
                                    hidden=true
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 车辆分类 -->
                        <el-table-column prop="vehicleType"
                                    :label="$t('offering.resource.vehicleType')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 排期时间（开始） -->
                        <el-table-column prop="starttime"
                                    :label="$t('offering.resource.vehiclestarttime')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    :formatter="dateFormat"
                                    fixed>
                        </el-table-column>
                        <!-- 排期时间（结束） -->
                        <el-table-column prop="endtime"
                                    :label="$t('offering.resource.vehicleendtime')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    :formatter="dateFormat"
                                    fixed>
                        </el-table-column>
                        <!-- 实际培训时间（天） -->
                        <el-table-column prop="actualdays"
                                    :label="$t('offering.resource.vehicleactualdays')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                          <template slot="header">
                            <el-tooltip placement="bottom-start" effect="light" >
                              <div slot="content">
                                需要与车辆的使用时间（开始）、使用时间（结束）所选择的时长一致
                              </div>
                              <span>{{$t('offering.resource.vehicleactualdays')}}
                              <em class="el-icon-question" style="color: #1C69D3"></em></span>
                            </el-tooltip>
                          </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <br/>
            <br/>
            <br/>
            <div id="divMaterial" style="display:none;" class="ax_default">
                <div class="ax_default">
                    <div style="width:130px;" class="ax_default _btn-default" id="btnDiv" data-label=".btn-default">
                        <div tabindex="0" id="btnDiv_div">
                        </div>
                        <div style="width:130px;" class="text " id="btnDiv_text">
                            <p>
                                <span style="text-decoration: none;">{{ $t('offering.resource.material') }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="ax_default _图片_" id="picDiv">
                        <img alt="" class="img " id="picDiv_img" src="../../../../../assets/img/learning/material.png">
                        <div class="text " id="picDiv_text" style="display: none; visibility: hidden;">
                          <p></p>
                        </div>
                    </div>
                    <div style="float:right;margin-right:30px;">
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <div style="width: 100%;">
                    <!-- 表头动态展示 -->
                    <el-table
                        ref="materialTable"
                        :data="dataForm.materialList"
                        border
                        style="width: 100%;">
                        <!-- 领用单号 -->
                        <el-table-column prop="roomName"
                                    :label="$t('offering.resource.materialRequisitionsId')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    fixed>
                        </el-table-column>
                        <!-- 排期时间（开始） -->
                        <el-table-column prop="starttime"
                                    :label="$t('offering.resource.materialstarttime')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    :formatter="dateFormat"
                                    fixed>
                        </el-table-column>
                        <!-- 排期时间（结束） -->
                        <el-table-column prop="endtime"
                                    :label="$t('offering.resource.materialendtime')"
                                    header-align="center"
                                    align="center"
                                    min-width="110"
                                    :show-overflow-tooltip=true
                                    :formatter="dateFormat"
                                    fixed>
                        </el-table-column>
                      </el-table>
                </div>
            </div>
        </el-card>
        <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button @click="sendEdit" v-if = initIsShowEdit
                           type="primary">{{ $t("course.edit") }}</el-button>
                <el-button @click="btnSaveNextStep"
                           type="primary">{{ $t("course.next") }}</el-button>
            </el-row>
        </div>
        <CheckDialog
          :dialogVisible="dialogVisible"
          @checkDialogOk="checkDialogOk"
          :checkForm="checkForm">

        </CheckDialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
import CheckDialog from '@/components/rm/checkDialog/index'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps, Step, CheckDialog },
  props: ['message', 'passOfferingId', 'isShowEdit'],
  inject: ['toTop'],
  data () {
    return {
      tips:false,
      isTencentA:false,
      linkShowEnd:false,
      linkShow: true,
      errorShow: false,
      initIsShowEdit:'',
      courseId: '',
      cData: [],
      dataIsSaveAll: '',
      multipleTable: [],
      multipleSelection: [],
      multipleSelectionChange: [],
      dialogTableVisibles: false,
      popover4Show: false,
      outerVisible: false,
      innerVisible: false,
      loading: false,
      selectTable: [],
      isSubString:false,
      dataForm: {
        offeringId: '',
        deadLineFlag: 'd',
        courseConditionList: [],
        courseLimidealerList: [],
        courseGroupList: [],
        menuId: '',
        addressbaidu: 0,
        siteId: '',
        siteName: '',
        siteCode: '',
        siteClassNameCn: '',
        cityId: '',
        cityCode: '',
        cityName: '',
        radio: '',
        chekex1: '',
        chekex2: '',
        active: 0,
        id: 45,
        sort: 0,
        courejoblist: [],
        deadLineDays: '2',
        repeatRegistFlag: '20',
        waitingListFlag: '20',
        collectionDemandFlag: '20',
        limitVisiableFlag: '10',
        sendNoticeFlag: '10',
        limitPartTimeJob: '20',
        replaceUserFlag: '10',
        revokeRegistFlag: '20',
        limitRegistFlag: '1',
        limitCourseFlag: '20',
        limitDefineFlag: '3',
        startdate: '',
        enddate: '',
        trainerList: [],
        roomList: [],
        vehicleList: [],
        materialList: [],
        materialDetailList: [],
        offeringStatus:'',
        courseTeamCatalogSecond:'',
        siteNameAndClassnameAndType: '',
      },
      // 排期learning的资源结构体
      offeringResourcesDto: {
        offeringInfoDto: {
          offeringId: 0,
          siteId: '',
          siteDisplay: '',
          cityId: ''
        },
        offeringTrainerDtoList: [],
        offeringVehicleDtoList: [],
        offeringRoomDtoList: [],
        offeringMaterialDtoList: [],
        offeringMaterialDetailDtoList: []
      },
      // 排期传入的参数
      afferentParam: {
        startTime: '2019-09-01 09:00', // 开始时间
        endTime: '2019-09-03 18:00', // 结束时间
        siteId: '112', // 场地id
        courseId: '2', // 课程id
        sessionId: '',
        type: 'vehicle', // 默认打开tab
        selectedResource: { // 编辑回填的参数
          selectedClassroomListDTO: {
            selectedClassroomItemDTOList: [
              {
                id: '1', // 资源id
                classroomId: '101',
                roomCnAbbr: '专业教室1',
                dateS: '2019-09-01 09:00',
                dateE: '2019-09-03 18:00',
                days: 3
              }
            ]
          },
          selectedTrainerListDTO: {
            selectedTrainerItemDTOList: [
              {
                id: 2,
                userName: '张三',
                dateS: '2019-09-01 09:00',
                dateE: '2019-09-03 18:00',
                days: null
              }
            ]
          },
          selectedVehicleListDTO: {
            selectedVehicleItemDTOList: [
              {
                id: 3,
                chassisNo: 'LBVHZ5107',
                dateS: '2019-09-02 09:00',
                dateE: '2019-09-02 09:00',
                days: null
              }
            ]
          }
        }
      },
      // 测试使用 S -------------------------------------------------------------------------
      isShowSchedulingDialog: false,
      // 测试使用 E -------------------------------------------------------------------------
      isShowSuboSite: false,
      dataListLoading: false,
      dataRule: {
        traineractualdays: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        waitingListFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        coursePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      },
      isTencent: false,
      conferenceRoomForm: {
        subject: '',
        start: '',
        end: '',
        isRecurring: '1',
        recurrentType: '1',
        untilType: 1,
        until: '',
        isMuteEnableJoin: '1',
        allowBeforeHost: '1',
        isAutoRecord: '1',
        isWaitingRoom: '0',
        offeringId: ''
      },
      isRecurringOptions: this.enums['TMMeetingType'],
      isAutoRecordOptions: this.enums['TMAutoRecordType'],
      isMuteEnableJoinOptions: this.enums['TMMuteEnableJoin'],
      allowBeforeHostOptions: this.enums['TMAllowInBeforeHost'],
      recurrentTypeOptions: this.enums['TMRecurringType'],
      isWaitingRoomOptions: [
        {
          code: '1',
          name: '是'
        },
        {
          code: '0',
          name: '否'
        }
      ],
      untilTypeOptions: [
        {
          value: 0,
          label: '按日期结束重复'
        },
        {
          value: 1,
          label: '按次数结束重复'
        }
      ],
      dialogVisible: false,
      checkForm: {
        meetingCode: '',
        joinUrl: '',
        subject: '',
        date: '',
        recurrentType: '',
        titleCode: '',
        recurrentDate: '',
        isRecurring: '0'
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {
    tencentConference() {
      if (this.dataForm.roomList.length > 0) {
        for (let i = 0; i < this.dataForm.roomList.length; i++) {
          if (this.dataForm.roomList[i].siteCnName === '腾讯会议') {
            return true
          }
        }
      } else {
        return false
      }
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.dataForm.offeringId = this.$route.query.offeringId
    this.$eventHub.$on('offbaseAdd', data => {
      this.again()
    })
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted');
  },
  beforeCreate () {
    console.log('beforeCreate');
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount');
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate');
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated');
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy');
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
      // #TODO 再次进入页面初始化数据
      console.log('再次进入 offeringResources')

      console.log(this.$route.query.offeringId)
      this.init(this.$route.query.offeringId)
      
    }
    
    if (this.$route.query.isShowEdit !== undefined && this.$route.query.isShowEdit !== '') {
      this.initIsShowEdit = this.$route.query.isShowEdit
    }
  },
  // 方法集合
  methods: {
    // 设置初始化为空
    again () {
      // TODO data 数据设置为空
    },
    // 初始化数据
    init (offeringId) {
      // TODO data 初始化数据
      this.linkShowEnd = false,
      this.linkShow = true,
      this.errorShow = false,
      this.again()
      console.log(offeringId)
      if (offeringId !== undefined) {
        this.dataForm.offeringId = offeringId
        this.afferentParam.sessionId = offeringId
        this.getOfferingInfo()
      }
      this.dataForm.offeringId = offeringId
    },
    // 获取初始数据
    getOfferingInfo () {
      this.$request.post('/learning/offeringtencentmeeting/savedtoMeeting',
        { offeringId: this.dataForm.offeringId }
      ).then((res, total, code, data) => {
        if(data.data == null){
          this.linkShow = false
          this.linkShowEnd = false
          this.errorShow = true
        }
        this.$request.get('/learning/base/offeringinfo/getBaseInfo/' + this.dataForm.offeringId
                ).then((resp, total, code, data) => {
                    console.log(resp.linkShow + '66666')
                    if(resp.linkShow  == false){
                      this.linkShow = false
                      this.linkShowEnd = true
                      this.errorShow = false
                  }
                  console.log(resp.offeringStatus+'发布状态')
                  if(resp.offeringStatus === '10') {
                      this.linkShowEnd = false
                      this.linkShow = false
                      this.errorShow = false
                      }
                console.log(resp.isDealerAndRemote+"66666666"+resp.isTencentSite)
                   if(resp.isTencentSite === "0" && resp.isDealerAndRemote === "1"){
                      this.isSubString = true
                   }
                   if(resp.isTencentSite === "1"){
                      this.isSubString = false
                      this.tips = true
                   } else {
                      this.tips = false
                   }
        if (res) {
        console.log(res, '查询返回值=============')
          this.isTencent = true
          this.conferenceRoomForm.subject = res.subject
          if (res.end.length === 16) {
            this.conferenceRoomForm.end = `${res.end}:00`
          } else {
            this.conferenceRoomForm.end = res.end
          }
          if (res.start.length === 16) {
            this.conferenceRoomForm.start = `${res.start}:00`
          } else {
            this.conferenceRoomForm.start = res.start
          }
          if (res.until && res.until.length === 16) {
            this.conferenceRoomForm.until = `${res.until}:00`
          } else {
            this.conferenceRoomForm.until = res.until
          }
          this.conferenceRoomForm.isRecurring = res.isRecurring
          this.conferenceRoomForm.recurrentType = res.recurrentType
          // this.conferenceRoomForm.untilType = res.untilType
          this.conferenceRoomForm.isMuteEnableJoin = res.isMuteEnableJoin
          this.conferenceRoomForm.allowBeforeHost = res.allowBeforeHost
          this.conferenceRoomForm.isAutoRecord = res.isAutoRecord
          this.conferenceRoomForm.isWaitingRoom = res.isWaitingRoom
          this.checkForm.joinUrl = res.joinUrl
          this.checkForm.meetingCode = res.meetingCode.split('')
          let titleCode = res.meetingCode.split('')
          // 腾讯会议号 9位格式
          if(this.checkForm.meetingCode.length < 11){
            titleCode.splice(3, 0, ' ')
            titleCode.splice(7, 0, ' ')
            this.checkForm.meetingCode.splice(3, 0, '')
            this.checkForm.meetingCode.splice(7, 0, '')
          }
          titleCode.splice(3, 0, ' ')
          titleCode.splice(8, 0, ' ')
          this.checkForm.meetingCode.splice(3, 0, '-')
          this.checkForm.meetingCode.splice(8, 0, '-')
          let replaceTwo = titleCode
          let replaceOne = this.checkForm.meetingCode
          this.checkForm.meetingCode = replaceOne.join('')
          this.checkForm.titleCode = replaceTwo.join('')
          this.checkForm.subject = res.subject
          console.log(res.start.replace(/-/g, '/'), '------------')
          // this.checkForm.recurrentType = res.recurrentType
          this.conferenceRoomForm.recurrentType = res.recurrentType
          this.checkForm.isRecurring = res.isRecurring
          let recurrentDate = ''
          if (res.until === null) {
            this.conferenceRoomForm.recurrentType = ''
            recurrentDate = `${res.start.substring(0, 10).replace(/-/g, '/')}-${res.end.substring(0, 10).replace(/-/g, '/')} ${res.start.substring(11, 16)}-${res.end.substring(11, 16)}`
          } else {
            // this.conferenceRoomForm.recurrentType = res.recurrentType === '0' ? '每天' : '周一至周五' 
            recurrentDate = `${res.start.substring(0, 10).replace(/-/g, '/')}-${res.until.substring(0, 10).replace(/-/g, '/')} ${res.start.substring(11, 16)}-${res.end.substring(11, 16)}`
          }
          console.log(this.conferenceRoomForm.untilType)
          this.checkForm.recurrentType = res.recurrentType === '0' ? '每天' : '周一至周五'
          this.checkForm.recurrentDate = recurrentDate
          console.log(res.start.replace(/-/g, '/'), '------------')
          this.checkForm.date = `${res.start.replace(/-/g, '/')}-${res.end.substring(11, 16)}`
          // 如果状态是20 就显示提示隐藏连接
          if (res.meetingStatus === 20 && res.meetingCode !== ""){
            if (resp.linkShow == false){
              this.linkShowEnd = true
             } else {
              if (res.joinUrl !== ""){
                this.linkShow = true
              } else{
                this.errorShow = true
              }
             }
          } else if (res.meetingStatus === 20){
            if (resp.linkShow == false) {
              this.linkShowEnd = true
            } else {
              this.linkShow = false
              this.errorShow = true
            }
          }
        } else {
          this.isTencent = false
        }
      }).catch(() => {
        // this.$message('444')
      })
      console.log('getOfferingInfo :' + this.dataForm.offeringId)

      this.$request.get('/learning/offeringResources/getResources',
        { offeringId: this.dataForm.offeringId }
      ).then((res, total, code, data) => {
        console.log(data)
        if (data.data !== 'undefined' && data.data !== null) {
          console.log('11111')

          if (data.data) {
            this.dataForm.offeringId = data.data.offeringInfoDto.offeringId
            this.dataForm.siteId = data.data.offeringInfoDto.siteId
            this.dataForm.siteName = data.data.offeringInfoDto.siteName
            this.dataForm.startdate = data.data.offeringInfoDto.startdate
            this.dataForm.cityId = data.data.offeringInfoDto.cityId
            this.dataForm.cityName = data.data.offeringInfoDto.cityName
            this.dataForm.enddate = data.data.offeringInfoDto.enddate
            this.dataForm.trainerList = data.data.offeringTrainerDtoList
            this.dataForm.roomList = data.data.offeringRoomDtoList
            console.log(data.data.offeringRoomDtoList)
            this.dataForm.siteClassNameCn=data.data.offeringInfoDto.siteClassNameCn
            this.dataForm.vehicleList = data.data.offeringVehicleDtoList
            this.dataForm.materialList = data.data.offeringMaterialDtoList
            this.dataForm.materialDetailList = data.data.offeringMaterialDetailDtoList
            // 对编辑按钮赋所需要的值
            this.dataForm.offeringStatus = data.data.offeringInfoDto.offeringStatus
            this.dataForm.courseTeamCatalogSecond = data.data.offeringInfoDto.courseTeamCatalogSecond

            this.dataForm.siteNameAndClassnameAndType = data.data.offeringInfoDto.siteName
            if (data.data.offeringInfoDto.siteClassNameCn) {
                this.dataForm.siteNameAndClassnameAndType = this.dataForm.siteNameAndClassnameAndType + ',' + data.data.offeringInfoDto.siteClassNameCn
            }
            if (data.data.offeringInfoDto.cityName) {
                this.dataForm.siteNameAndClassnameAndType = this.dataForm.siteNameAndClassnameAndType + ',' + data.data.offeringInfoDto.cityName
            }
            this.$request.get('/learning/offeringtencentmeeting/judgeMeetingSite?courseId=' + data.data.courseInfoDto.courseId, {}).then((res, total, code, data) => {                                                                   
              console.log(res, data)
              if (data.data) {
                this.$request.get(
                  '/rm/siteinfo/listNoAuth',
                  {
                    page: 1,
                    limit: 10,
                    siteNo: data.data.siteNo
                  }
                ).then((res, total, code, data) => {
                  console.log(res.records, data.records)
                  let index = this.dataForm.siteNameAndClassnameAndType.indexOf(',')
                  if(index!==-1 || index==-1){
                  let str = this.dataForm.siteNameAndClassnameAndType 
                  str = str.substring(0, index)

                  //判断满足条件后再截取字符串
                  if(this.isSubString === false){
                      this.dataForm.siteNameAndClassnameAndType = str
                  }
                  }
                  
                })
               
              } else {
                this.$request.get(
                  '/rm/siteinfo/listNoAuth',
                  {
                    page: 1,
                    limit: 10,
                    siteNo: 'CD100117'
                  }
                ).then((res, total, code, data) => {
                  console.log(res.records, data.records)
                  if (this.dataForm.siteId === res.records[0].id) {
                    let index = this.dataForm.siteNameAndClassnameAndType.indexOf(',')
                    let str = this.dataForm.siteNameAndClassnameAndType
                    str = str.substring(0, index)
                     if(this.isTencentA === false){
                    this.dataForm.siteNameAndClassnameAndType = str
                     } 
                    }
                })
                
              } 
            
            })
          }
        }
      }).catch(() => {
        // this.$message('444')
      })
        })
    },
    // 腾讯会议查看
    checkClick() {
      this.dialogVisible = true
    },
    // 关闭查看弹框
    checkDialogOk() {
      this.dialogVisible = false
    },
    // 保存方法
    btnSave () {
      // TODO 成功调用  this.sendSave()
    },
    // 保存并下一步
    btnSaveNextStep () {
     
      // TODO  成功调用 this.sendMsg()
      this.sendMsg()
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      this.$emit('onShowModer', 'offconditionsend')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offeringResourcesSave')
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$emit('onShowModer', e)
    },
    // 取消按钮
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    dateFormat (row, column, cellValue) {
      let datetime = cellValue
      if (datetime) {
        datetime = new Date(datetime.replace(/-/g,"/"))
        let y = datetime.getFullYear() + '-'
        let mon = (datetime.getMonth() + 1) < 10 ? '0' + (datetime.getMonth() + 1) + '-' : (datetime.getMonth() + 1) + '-'
        let d = datetime.getDate() < 10 ? '0' + datetime.getDate() + ' ' : datetime.getDate() + ' '
        let h = datetime.getHours() < 10 ? '0' + datetime.getHours() + ':' : datetime.getHours() + ':'
        let min = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes()
        return y + mon + d + h + min
      }
      return ''
    },
    sendEdit(){
      console.log("sendEdit")
      this.$router.push({ path: 'learning-offering-offeringEdit', query: { offeringId: this.dataForm.offeringId } })
    },
    checkEditRole () {
      if (this.dataForm.offeringStatus === '30' || this.dataForm.offeringStatus === '40') {
          return false
      }
      if (this.$hasPermission('learning:offering:offeringEdit')) {
          return true
      }
      if (this.$hasPermission('TEAM:' + this.dataForm.courseTeamCatalogSecond)) {
          return true
      }
      if (this.$hasPermission('learning:offering:editselfcreated')) {
          return true
      }
      return false
    }
  }
}
</script>
<style lang='scss'>
  .div a{
    cursor: pointer;
  }
  .btnTrainer{background: none;}
  .btnTrainer:active {background: #ffffff;border-color: #ffffff;color: #ffffff;}
  .btnTrainer:focus {background: #ffffff;border-color: #ffffff;color: #ffffff;}
  .btnTrainer:hover {background: #ffffff;border-color: #ffffff;color: #ffffff;}
  .el-icon-trainer{
    background: url(../../../../../assets/img/learning/trainer.png) center no-repeat;
    background-size: cover;
  }
  .el-icon-trainer:before{
    content: "替";
    font-size: 16px;
    visibility: hidden;
  }
  .el-icon-room{
    background: url(../../../../../assets/img/learning/room.png) center no-repeat;
    background-size: cover;
  }
  .el-icon-room:before{
    content: "替";
    font-size: 16px;
    visibility: hidden;
  }
  .ax_default {
    font-family:'Arial Normal', 'Arial', sans-serif;
    font-weight:400;
    font-style:normal;
    font-size:13px;
    letter-spacing:normal;
    color:#333333;
    vertical-align:none;
    text-align:center;
    line-height:normal;
    text-transform:none;
  }
  .viewConferenceContentClass {
    width: 100%;
    min-height: 50px;
    border: 1px solid #dddddd;
    padding: 10px;
    margin-top: 14px;
    padding-bottom: 3px;
    .el-form-item {
      width: 95% !important;
      margin-left:18px;
      height:32px !important;
    }
  }
  #btnDiv_div {
    position:absolute;
    left:0px;
    top:0px;
    width:119px;
    height:36px;
    background:inherit;
    background-color:rgba(255, 255, 255, 1);
    box-sizing:border-box;
    border-width:1px;
    border-style:solid;
    border-color:rgba(221, 221, 221, 1);
    border-radius:4px;
    -moz-box-shadow:none;
    -webkit-box-shadow:none;
    box-shadow:none;
    font-family:'Arial Normal', 'Arial', sans-serif;
    font-weight:400;
    font-style:normal;
    color:#169BD5;
    text-align:right;
  }
  #btnDiv {
    border-width:0px;
    position:absolute;
    width:119px;
    height:36px;
    display:flex;
    font-family:'Arial Normal', 'Arial', sans-serif;
    font-weight:400;
    font-style:normal;
    color:#169BD5;
    text-align:right;
  }
  #btnDiv .text {
    position:absolute;
    align-self:center;
    padding:0px 12px 0px 12px;
    box-sizing:border-box;
    width:100%;
  }
  #btnDiv_text {
    border-width:0px;
    word-wrap:break-word;
    text-transform:none;
  }
  #picDiv_img {
    border-width:0px;
    position:absolute;
    left:10px;
    top:6px;
    width:24px;
    height:24px;
  }
  #picDiv {
    border-width:0px;
    position:absolute;
    width:24px;
    height:24px;
    display:flex;
  }
  #picDiv .text {
    position:absolute;
    align-self:center;
    padding:2px 2px 2px 2px;
    box-sizing:border-box;
    width:100%;
  }
  #picDiv_text {
    border-width:0px;
    word-wrap:break-word;
    text-transform:none;
    visibility:hidden;
  }
  .grid-content {
      border-radius: 4px;
      min-height: 36px;
  }
  .tisp{
      margin-left: 7.8rem;
      float: left;
      margin-top:0.7rem;
    }
    .label_text {
      .el-form-item__label{
      width:148px !important;
      position:absolute;
      left:5px;
      }
    }
    .row_jj{
      margin-bottom:3px !important;
    }
</style>
